import React, { isValidElement, useRef, useState, useEffect, Fragment} from 'react';
import { Box, styled } from '@mui/system';
import { TextField,  Stack, CircularProgress, LinearProgress, Grid } from '@mui/material';

import { LoadingButton } from '@mui/lab';

import InfiniteScroll from "react-infinite-scroll-component";
import uniqueId from 'lodash/uniqueId';
import debounce from 'lodash/debounce';
//import Slider from "react-slick";

import Icon from 'app/components/Icon';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Heading from './Heading';
import { useWindowSize } from "app/hooks/useWindowSize";
import { topBarHeight } from '../utils/constant';
import Timer from './Timer';
import Api from '../utils/Api';
import interval from '../../config/interval';
import Alert from 'app/components/Alert';

const GridItem = styled(Grid)(({ theme, mc }) => ({
    [theme.breakpoints.down('sm')]: {
        maxWidth: mc > 1 ? `${(100/parseInt(mc))}%` : null,
        flexBasis: mc > 1 ? `${(100/parseInt(mc))}%` : null,
    }
}));

const Container = styled('div')(({ theme, height, mh, hd }) => ({
    maxHeight: mh ? mh : 'inherit',
    height,//: isNaN(height) ? `${height}` : `${height}px`,
}));

const ActionButton = styled(LoadingButton)(({ theme, cstyle, ty,loading }) => ({
    width : ty==='icon' && loading ? "36px" : "auto",
    padding: `3px ${ty==='text' ? 11 : (loading ? 0 : 5)}px`, 
    ...JSON.parse(cstyle),
}));

const ActionIcon = styled(Icon)(({ theme, color,size }) => ({
    color, height:'auto',
    fontSize: `${size}px !important`,
    lineHeight:`${size}px !important`
}));

const SliderBox = styled('div')(({ spacing, height }) => ({ height, '& > div':{ gap:spacing }}));

const ItemList =(props) => {
    
    const counter = useSelector(store=>store.counter[props?.counter] || 0);
    const navigate = useNavigate();
    
    const [state,setIState] = useState({});
    const [text,setText] = useState('');
    const url = props?.url || '';
    const headerRef = useRef();
    const [heightHdr,setHeightHdr] = useState(0);
    const windowSize = useWindowSize();
    const [isMbl, setIsMbl] = useState(0);

    const slider = props?.slider || false;
    const columns = props?.columns || 1;
    const spacing = props?.spacing || 0;

    /*
    const sliderConfig = {
        initialSlide:0,
        dots: false,
        infinite: false,
        autoplay: false,
        speed: 500,
        slidesToShow: columns,
        slidesToScroll: 1,
      //  adaptiveHeight:true,
         swipeToSlide: true,
        variableWidth: true,
        className:"islider",
        ...props?.sliderConfig,
    };
    */

    const uuid = uniqueId("ItemList-");
    const stickyHeader = props?.stickyHeader || false;
    let maxLimit = props.maxLimit ? props.maxLimit : 100000, maxPage = props.maxPage ? props.maxPage : 0;

    let sinceInterval = props.sinceTime || (interval?.itemList || 60);
            
    let limit = props.limit || maxLimit;
    if( maxPage === 0 ) 
        maxPage = Math.ceil(maxLimit/limit);
    else 
        maxLimit = maxPage * limit;
    
    const skeleton = props?.skeleton || null;
    const nofsi = props?.nofsi || limit;
    const shLdOnEr = props?.showLoadingOnError || false;

    useEffect(()=>{
        
        var i, data = [];
        if( skeleton ){
            for(i = 1; i<= nofsi; i++){
                data.push(i);
            }
        }

        setIState({
            data,
           // skeleton: null,
            sinceDate: null,
            isLoading: false,
            isSearching:false,
            isProcessing: false,
            refreshing: false,
            action: '',
            removedKeys: [],
            loaded: false,
            limit,
            maxLimit,
            maxPage,
            page: 1,
            completed: false,
            error: false,
            buttons: props.buttons || [],
        });

        onResize();
        window.addEventListener("resize", ()=>onResize());

        if( !props.loading)
            getData(0);
        
        return ()=>{ 
            window.removeEventListener("resize", ()=>onResize());
            setIState({}); 
        };
    },[props.loading, maxPage ,limit, maxLimit]);

    useEffect(()=>{
        setIsMbl(windowSize.width <=560 ? 1 : 0);
        return () =>{};
    },[windowSize]);

    const onResize = () =>{
        setHeightHdr(headerRef?.current?.clientHeight || 0);
    }

    const setState = (sts)=>{
        setIState(ps=>({...ps,...sts}));
    }

    const onInterval = (s,st) =>{
        if( st === 1 && state.sinceDate )
            getData(st, {since : state.sinceDate});
        if( st === 2 )
            getData(st);
    }

    const parseItems = (data) => {
        if( data && data[0] && data[0].uuid){
            let list = {};
            data.map(d=>{
                if( d?.uuid && !list[d?.uuid] )
                    list[d.uuid] = d;
                return d;
            });
            data = Object.values(list);
        }   
        return data;     
    }

    const delay = ms => new Promise(res => setTimeout(res, ms));

    const getData =async(a, params = {})=>{
        try {

            var _state = state;
            _state.error = false;

            if( !a){

               // if( !_state.refreshing && !_state.isSearching && (_state.loaded || !_state.skeleton) ){
                  //  if( !params?.refreshing )
                       // _state.data = []; 
                //}

                if( _state.loaded ){
                    _state.data = [];
                    if( skeleton ){
                        for(let i = 1; i <= nofsi; i++){
                            _state.data.push(i);
                        }
                    }  
                }

                _state.loaded = false;
                _state.isLoading = false;
                _state.page = 1;
                _state.completed= false; 
                _state.error = false;
                setState(_state);
            }

            if( a===2){
                _state.page = 1;
            }

            if( !state.isLoading ){
                if( !params?.since && a !== 2 )
                    _state.isLoading = true;
                
                var _url = url;  

                _url = _url+(_url.includes('?') ? '&' : '?' )+'page='+(params?.since ? 1 : _state.page)+'&limit='+limit;
                let _txt = params?.text || text;
                if( _txt.length > 2 )
                    _url += "&q="+encodeURI(_txt);
                
                if( params?.since )
                    _url += "&since="+params?.since;

                if( props?.onLoading )
                    props.onLoading(true,_state.loaded);

                setState(_state);
                
                if( !_state.loaded && props?.delay )
                    await delay(props?.delay);

                var res = await Api.get(_url);

                _state.isLoading = false;
                _state.isSearching = false;
                _state.refreshing = false;
            
                if( props?.onLoading )
                    props.onLoading(false,_state.loaded);
            
                let ldd = _state.loaded;
                if( res.success ){
            
                    if( props?.since && res?.data?.datetime && (params?.since || (!a && !_state.loaded) ) )
                        _state.sinceDate = res?.data?.datetime;

                    var data = [], list  = res.data?.list || [];
                    if( params?.since ){
                        data = [...list,..._state.data];
                    } else {
                        data = a === 1 ? [..._state.data, ...list] : list;
                        if( list.length === 0 && text.length > 2 )
                            data = [];

                        _state.page++;
                        if(!a)
                            _state.loaded = true;
                        
                        if( _state.page > _state.maxPage || (res.data?.next || false) === false )
                            _state.completed = true;
                    }

                    onLoad(res.data?.total || 0, data, false,res.data, ldd);
                    data = parseItems(data);
                    _state.data = props?.filterItems ? props.filterItems(data) : data;
                }

                if( !res.success && res.message && _state.page < 2 ){
                    _state.error = res.message || "Unable to process your request";
                    onLoad(0,[], res.message);
                }

                if( shLdOnEr && _state?.error ){
                    _state.error = false;
                    _state.isLoading = true;
                }

                setState(_state);
            }
        } catch (error){
            setState({ isLoading: false, completed: true, error: "Unable to process request" });
        }
    }

    const onSearch = (e) =>{
        let v = (e?.target?.value || '').toString().trim();
        setText(v);
        setState({ isSearching: v.length > 2});
        if( !state.isLoading )
            getData(0, v.length > 2 ? {text: v} : {});
    }

    const loadMore = (ty = 1) => {
        if( state.loaded && !state.completed && !state.isLoading )
            getData(ty);
    }

    const onLoad = (total, data, error, res, ldd) =>{
        if( props.onLoad )
            props.onLoad(total, data, error, res, ldd); 
    }

    const itemAction = async(url,id, key, btn, item) => {

        if( btn?.method === 'LINK'){
            navigate(`/${url}`,{state:item});
            return;
        }

        let res;
        if( state.isProcessing ) return ;
        setState({ isProcessing: true, action: url });
        
        res = { success:true, data:[] };
                
        if ( btn?.method === 'POST')
            res = await Api.post(url,{});
        else
            res = await Api.get(url);

        setState({ isProcessing: false });
        if( res.success ){
            if( btn?.remove ) {
                let _data = filterData(item, key, id, url);
                if( props.onRemove ){
                    if(!state.completed && state.data.length < 6)
                        loadMore(0);
                    props.onRemove(_data, url, item, id, key);
                }
            }
            if( props.onActionCall )
                props.onActionCall(res?.data, false, url, item, id, key);
        } else if ( res.message ){
            if( props.onActionCall )
                props.onActionCall(res?.data, res.message, url, item, id, key);
        }
    }

    const filterData = (item, key, id, url) =>{
        let { data , removedKeys } = state;
        removedKeys.push(id);
        data = data.filter(_item=>_item[key] !== id);
        setState({ data, removedKeys });
        return data;
    }

    const renderSearchBox = () =>{
        return <div className={`srch ${props.heading ? (isMbl ? 'mb' : ''): 'mb'}`}>
            <TextField 
                size="small" 
                placeholder="Search ..."
                defaultValue=""
                InputProps={{ startAdornment:<Icon>search</Icon> }}
                onChange={debounce((t)=>onSearch(t), 600)}
            >
            </TextField>
        </div>
    }

    const renderHeader = () =>{
        let srchBox = props?.searchBox ? renderSearchBox() : null;
        let heading = props.heading || null;
        
        let xs = !heading || isMbl ? 12 : 7;
        
        let cnt = <Grid container spacing={0}> 
            {heading && <Grid item xs={xs} md={srchBox ? 8 : 12}>
                <Heading icon={props?.headingIcon} mb={0} border="0" counter={counter}>{heading}</Heading>
            </Grid>}
            {srchBox && <Grid item xs={12-xs > 0 ? 12-xs : 12} md={heading ? 4 : 12}>{srchBox}</Grid>}
        </Grid>;

        if( srchBox || heading ){
            return <div ref={headerRef} className={`hdr ${stickyHeader ? 'stk' : ''}`}>
                {props?.containerHeader ? props.containerHeader(cnt) : cnt}
                {renderLoadMore(1,true)}
            </div>;
        }

        return null;
    }

    const renderButtons = (item,index) =>{

        if( !state.buttons.length)
            return null;
        
        let { isProcessing, action } = state;

        return (<>
            {state.buttons.map((btn,bi)=>{
                let key = (btn?.key || '').trim(), url = (btn?.url || "").trim(), styl = btn.style || {};
                let id = item[key] || null, size = btn?.size || 16, processing = false, variant = btn?.variant || 'contained';
                
                url = url.replace('[KEY]', id || '');
                if( btn?.bg ) styl['backgroundColor'] = btn?.bg;
                if( bi > 0) styl={ marginLeft:6 };
                if( btn?.color ) styl['color'] = btn?.color;
                if( btn?.borderColor ) styl['borderColor'] = btn?.borderColor;
                
                if( isProcessing && action === url)
                    processing = true;

                if( btn?.icon && !btn?.text ){
                    return <ActionButton 
                      className="btn-act icn"
                      cstyle={JSON.stringify(styl)} 
                      key={`btn_${id}_${bi}`} 
                      onClick={()=>itemAction(url, id, key, btn, item)} 
                      ty="icon"
                      loading={processing}
                      variant={variant}>
                        {processing ? '&nbsp;' : <ActionIcon color={btn?.color || ''} size={size}>{btn?.icon}</ActionIcon>}
                    </ActionButton>;
                }

                if( btn?.text ){
                    return <ActionButton 
                      ty="text"
                      className="btn-act txt"
                      cstyle={JSON.stringify(styl)} 
                      key={`btn_${id}_${bi}`} 
                      onClick={()=>itemAction(url, id, key, btn, item)} 
                      variant={variant}
                      loading={processing}
                      loadingPosition="start" 
                      startIcon={btn?.icon ? <ActionIcon color={btn?.color || ''} size={size}>{btn?.icon}</ActionIcon> : null}>
                        {btn?.text} 
                    </ActionButton>;
                }

                return null;
            })}
        </>);
    }

    const renderItem = (item,index) =>{
        let { loaded, isLoading } = state;

        if( loaded ){
            let buttons = renderButtons(item,index);
            return props.renderItem(item,index,buttons);
        } else {
            if( (props?.loading || isLoading) && skeleton )
                return skeleton(item,index);
        }
        
        return null;
    }

    const renderEmptyList = () =>{
        if( !state.loaded || state.isLoading )
            return null;
        let _text = props.emptyText || "No item found";
        if( isValidElement(_text) )
            return _text;

        if( text.length > 2 )
            _text = "No result found for '"+text+"'";
        return <p style={{ marginTop:'15px', padding:0,  marginBottom:'30px', color:"#666", textAlign:"center", fontSize:"15px" }}>{_text} !</p>;
    }
    
    const renderData = ()=>{
        const { data, error, isLoading, loaded } = state;   
        
        if( !loaded && isLoading && !skeleton && !props?.renderData ) 
            return null;

        if( loaded && !data.length ) 
            return renderEmptyList();

        let gs = 12;
        if( columns > 1 && windowSize.width >= 520){
            gs = Math.floor(12/columns);

            if( windowSize.width <= 767 ){
                gs = 6;
            } else if( windowSize.width <= 1100 ){
                if(columns === 4 && gs === 3)
                    gs = 4;                
            }

            /*
            if( gs === 4 && windowSize.width <= 767)
                gs = 6;
            if( gs === 3 && windowSize.width <= 680)
                gs = 6;

            if( column === 4 && gs === 3 && windowSize.width <= 1100)
                gs = 4;
            if( column === 3 && gs === 4 && windowSize.width <= 1100)
                gs = 6;
            */
        }

        if(  error) // && !(data || []).length
            return <Alert variant="outlined" severity="error" spacing={props?.errorMargin}>{error}</Alert>;
    
        if( props.renderData )
            return props.renderData(state,gs);

        return <Box sx={{ padding: props?.boxPadding || 0 }}>
            {slider ?
                <SliderBox className="slider" spacing={spacing} height={props?.sliderHeight}>
                    <div>
                        {(data || []).map((item,idx)=>{
                            let icnt = renderItem(item,idx);
                            if( !icnt ) return null;
                            return <div key={`itm_${idx}`}>
                                {icnt}
                            </div>;
                        })}
                    </div>
                </SliderBox>
            : <Grid container spacing={spacing}>
                {(data || []).map((item,idx)=>{
                    let icnt = renderItem(item,idx);
                    if( !icnt ) return null;
                    return <GridItem sx={props?.itemStyle || null} item xs={gs} mc={props?.minColumns || 1} key={`itm_${idx}`}>
                        {icnt}
                    </GridItem>;
                })}
            </Grid>}
        </Box>;
    }

    const renderLoading = () =>{
        const {  error , loaded  } = state;             
        return !props?.hideLoading && !error && !loaded && !skeleton ? <div className="ldr">
            <CircularProgress size={30} color="inherit" style={{ position:'absolute', left:'50%', top:'50%', marginTop:"-15px", marginLeft:'-15px'}} />
        </div> : null;
    }

    const renderLoadMore = (s,abs) =>{
        const { loaded , isLoading } = state; 
        if( !s || !(loaded && isLoading) ) return null;
        let style = abs ? {position:'absolute', width:"100%", zIndex:"1%"} : {};
        return props?.hideProgress ? null : <div style={style}><LinearProgress /></div>;
    }

    const renderContent = (hdrCmp, stickyHeader, moreViewBtn, limit, maxLimit, uuid) =>{

        const { data, completed, loaded , isLoading, error } = state;  
        
        return <Fragment>  

            {hdrCmp ? (!Array.isArray(hdrCmp) ? hdrCmp : hdrCmp(state)) : null}

            {renderLoading()}
            {moreViewBtn || limit === maxLimit ? renderData() : 
                <InfiniteScroll
                  dataLength={(data || []).length}
                //  height={windowSize.height-topBarHeight}
                 // height={contentHeight || 1}
                  next={loadMore}
                  hasMore={!completed}
                  loader={renderLoadMore(0,false)}
                  scrollableTarget={props?.scrollTarget || uuid}
                >
                    {renderData()}
                </InfiniteScroll>
            }
            {moreViewBtn ? <Fragment>
                {(!error && !completed && loaded) && (typeof moreViewBtn !== 'string' ? moreViewBtn(loaded && isLoading,loadMore) : <Box sx={{ fontWeight:"bold", marginTop:"10px" }}>
                    {loaded && isLoading ? <Stack direction="row" gap="6px"><CircularProgress size={16}/> Loading ...</Stack> : <a href="/" onClick={(e)=>{ e.preventDefault(); loadMore(); }}>{moreViewBtn}</a>}
                </Box>)}
            </Fragment> : !(props?.searchBox || props?.heading) && renderLoadMore(1,false)}

        </Fragment>;
    }

    const render = () =>{
             
        const { loaded , isLoading } = state;  
        let hdrCmp = props.headerComponent || null; 
        const moreViewBtn = props?.moreViewBtn || null;

        let hght = props?.height || (windowSize.height-topBarHeight);
        // if( props?.maxHeight )
          //  hght = null;
        if( stickyHeader )
            hght -= heightHdr;
        hght -= 1;
        if( props?.maxHeight ) hght = null;

        if( hght === '100%' || hght === 'auto' )
            hght = null;
        else 
            hght = moreViewBtn || (!props?.height && props?.scrollTarget) ? null : hght;

        var cprops = {};
        if( hght )
            cprops.height = hght;
        
        let content = renderContent(hdrCmp, stickyHeader, moreViewBtn, limit, maxLimit, uuid);
        
        return (
            <Fragment>
                {(props?.since || props?.interval) && <Timer time={props?.interval || sinceInterval} onInterval={s=>onInterval(s,props?.interval ? 2 : 1)}/>}
                <div className={`item-list ${props?.class || ''}`} sx={props?.style || {}}>
                    {stickyHeader && renderHeader()}   
                    <Container className={`cntr${isLoading && !loaded ? ' hdn' : ''}`} id={uuid} pt={(props?.searchBox || props.heading) && stickyHeader ? heightHdr : 0} mh={props?.maxHeight || null} hd={isLoading && !loaded ? 1 : 0} {...cprops}>

                        {!stickyHeader && renderHeader()}
                        {props?.container ? props.container(content,state) : content}
                    </Container>
                </div>
            </Fragment>
        );
    }

    return render();
}

export default ItemList;